import { PISANO_COLORS } from '@vision/theme';
import { ReportChartFeedbackBaseType, ReportTimeIntervalType } from '@vision/ui/enums';
import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { FeedbackBasedQuestionBasedMeasureRenderer, TrendChart3CompareRenderer } from '../../components';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartThemeSeries,
  extendDefaultChartValidationSchema,
} from '../default-chart.config';
import { TrendChart3Measures } from './trend-chart3.measures';

export const TrendChart3DefaultConfiguration: ReportChartConfiguration = {
  supportsLegendSettings: true,
  validationSchema: extendDefaultChartValidationSchema({
    withFeedbackBasedQuestionBased: true,
  }),
  measures: TrendChart3Measures,
  compareRendererComponent: TrendChart3CompareRenderer,
  measureRendererComponent: FeedbackBasedQuestionBasedMeasureRenderer,
  defaultFeedbackBasedQuestionBased: ReportChartFeedbackBaseType.FEEDBACK_BASED,
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    timeInterval: ReportTimeIntervalType.DAY,
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
    referenceDefinition: {
      active: true,
      value: { name: '', score: null },
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    xAxis: {
      ...DefaultReportChartThemeFont,
    },
    yAxis: {
      ...DefaultReportChartThemeFont,
      activeDisplayFormat: true,
      displayFormat: 'auto',
      minMaxValue: {
        minValue: null,
        maxValue: null,
      },
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: false,
      displayFormat: 'auto',
      roundingMethod: 'default',
      position: 'top',
    },
    serieDot: {
      active: false,
      symbolSize: 6,
      symbolType: 'circle',
      symbolFilling: 'full',
    },
    serieLine: {
      active: false,
      lineColor: PISANO_COLORS.dark[5],
      lineSize: 2,
      lineType: 'dashed',
    },
    series: {
      ...DefaultReportChartThemeSeries,
    },
  },
};
